import React from 'react'
import { Typography, useTheme, Box } from '@mui/material'
import { FormattedMessage } from 'react-intl'

interface Iprops {
  imageAssetId: string
  imageAssetName: string
  imageAssetUrl?: string
  isHeader: boolean
  onToggleHeader: (id: string) => void
}

const HeaderImageSelector: React.FC<Iprops> = ({
  imageAssetId,
  imageAssetName,
  imageAssetUrl,
  isHeader,
  onToggleHeader,
}) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        borderBottom: 'solid 1px lightgray',
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '2.5% 1%',
        paddingRight: 0,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {imageAssetUrl && (
          <Box
            component="img"
            src={imageAssetUrl}
            alt={imageAssetName}
            sx={{
              width: 40,
              height: 40,
              objectFit: 'cover',
              borderRadius: '4px',
              border: `1px solid ${theme.palette.divider}`,
            }}
          />
        )}
        <Typography variant="body2">{imageAssetName}</Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0 5%',
          borderRight: 'solid 2px lightgray',
        }}
      >
        <Typography
          onClick={() => onToggleHeader(imageAssetId)}
          sx={{
            padding: '5px 10px',
            borderRadius: '15px',
            cursor: 'pointer',
            backgroundColor: isHeader ? theme.palette.info.dark : 'transparent',
            color: isHeader ? 'white' : theme.palette.text.primary,
            fontWeight: isHeader ? 600 : 400,
            fontSize: '0.875rem',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              transform: 'scale(1.05)',
            },
          }}
        >
          <FormattedMessage id="set-as-header" />
        </Typography>
      </Box>
    </Box>
  )
}

export default HeaderImageSelector
